/* Long-form product template — behaviour
   Works without this file too: bundles are real radio inputs inside a real
   product form, so the page still adds to cart and checks out if JS fails. */
(function () {
  var root = document.querySelector('[data-lf-buybox]');
  if (!root) return;

  /* Gallery: swap the main image when a thumbnail is chosen */
  var mainImg = root.querySelector('.lf-main-img');
  root.querySelectorAll('[data-lf-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      root.querySelectorAll('[data-lf-thumb]').forEach(function (t) {
        t.setAttribute('aria-current', 'false');
      });
      thumb.setAttribute('aria-current', 'true');
      if (mainImg) {
        mainImg.src = thumb.dataset.src;
        mainImg.srcset = thumb.dataset.srcset || '';
        mainImg.alt = thumb.dataset.alt || '';
      }
    });
  });

  /* Bundles: keep the CTA price and sticky bar in step with the choice */
  var form = document.getElementById('lf-form');
  var ctaPrice = root.querySelector('[data-lf-cta-price]');
  var sticky = document.querySelector('[data-lf-sticky]');
  var spName = sticky && sticky.querySelector('[data-lf-sp-name]');
  var spPrice = sticky && sticky.querySelector('[data-lf-sp-price]');
  var spCompare = sticky && sticky.querySelector('[data-lf-sp-compare]');

  function sync() {
    var checked = root.querySelector('input[name="id"]:checked');
    root.querySelectorAll('[data-lf-opt]').forEach(function (opt) {
      var input = opt.querySelector('input');
      opt.classList.toggle('is-selected', !!input && input.checked);
    });
    if (!checked) return;
    if (ctaPrice) ctaPrice.textContent = checked.dataset.price;
    if (spName) spName.textContent = checked.dataset.name;
    if (spPrice) spPrice.textContent = checked.dataset.price;
    if (spCompare) spCompare.textContent = checked.dataset.compare || '';
  }
  root.querySelectorAll('input[name="id"]').forEach(function (input) {
    input.addEventListener('change', sync);
  });
  sync();

  /* Stop double submits while checkout loads */
  if (form) {
    form.addEventListener('submit', function () {
      document.querySelectorAll('[data-lf-submit]').forEach(function (b) {
        b.setAttribute('disabled', '');
      });
    });
    window.addEventListener('pageshow', function () {
      document.querySelectorAll('[data-lf-submit]').forEach(function (b) {
        b.removeAttribute('disabled');
      });
    });
  }

  /* Sticky bar: shown on mobile once the visitor has scrolled past the start point, except while the bundle picker is on screen */
  if (sticky) {
    document.body.appendChild(sticky);
    document.body.classList.add('lf-has-sticky');
    var offer = root.querySelector('[data-lf-offer]');
    var start = parseInt(sticky.getAttribute('data-lf-sticky-start'), 10) || 0;
    var update = function () {
      var scrolled = (window.pageYOffset || document.documentElement.scrollTop) >= start;
      if (!offer) return sticky.classList.toggle('is-visible', scrolled);
      var r = offer.getBoundingClientRect();
      var inView = r.top < window.innerHeight * 0.85 && r.bottom > 0;
      sticky.classList.toggle('is-visible', scrolled && !inView);
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }
})();
